export default __webpack_public_path__ + "static/media/react-logo.5bd77d01.png";